import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Value (USD)", two_table_header: "Total Value (USD)" },
  { value: "weight", label: "Total Weight (kg)", two_table_header: "Total Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Uruguay Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  showUiTrends: true,
  exportPDFInAnalytics: false,
  isShipmentGridNew: true,
  isViewAllGridNew: true,
  isUIGridNew: true,
  isUEGridNew: true,
  minimumDateAllowed: "2019-01-01",
  isImpExpGraph: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("uruguayExportLatestArrivalDate"),
    getSearchResult: getApiUrl("uruguayExportSearch"),
    getAnalyticsData: getApiUrl("analytics/uruguayExportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_uruguay_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_uruguay_exports"),
    getShipmentByID: getApiUrl("uruguayExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfUruguayExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/uruguayExportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.uy_export.country_small,
  countryCaps: globalCountryDetails.uy_export.country_caps,
  product_id: globalCountryDetails.uy_export.product_id,
  compare_product_id: globalCountryDetails.uy_export.compareProduct,
  country_CamelCase: globalCountryDetails.uy_export.product_id,
  countryCode: globalCountryDetails.uy_export.countryCode,
  countryType: globalCountryDetails.uy_export.countryType,
  manyCountryType: globalCountryDetails.uy_export.manyCountryType,
  countryTypeCode: globalCountryDetails.uy_export.countryTypeCode,
  redirectionID: globalCountryDetails.uy_export.redirectionID,
  analyticsCountryID: globalCountryDetails.uy_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipments Arrival Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: false,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: false,
    product_hscode: true,
    exporters: true,
    importers: false,
    allCategory: true,
    ports: true,
  },
  searchCategoryList: globalCountryDetails.uy_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortName",
  },
  filterObj: {
    countryOfDestinationRegion: "countryOfDestinationRegion",
    countryOfExportRegion: "countryOfExportRegion",
    exporterName: "exporterName",
    isExporter: "isExporter",
    standardLadingPortName: "standardLadingPortName",
    transportMode: "transportMode",
    hsCode: "hsCode",
    weight: "weight",
    shipmentValue: "shipmentValue",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
    incoterm: "incoterm",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    weight: "weight",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    weight: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfDestinationRegion: "countryOfDestination",
    countryOfExportRegion: "countryOfExport",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfDestinationRegion: [],
    countryOfExportRegion: [],
    exporterName: [],
    isExporter: [],
    standardLadingPortName: [],
    transportMode: [],
    hsCode: [],
    weight: [],
    shipmentValue: [],
    sections: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    shipperJurisdictionCountryRegion: [],
    incoterm: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfDestinationRegion: false,
    countryOfExportRegion: false,
    exporterName: false,
    isExporter: false,
    standardLadingPortName: false,
    transportMode: false,
    hsCode: false,
    weight: false,
    shipmentValue: false,
    sections: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    shipperJurisdictionCountryRegion: false,
    incoterm: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: categoryType.shipperDetails, eventKey: "16", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: categoryType.shipperDetails, eventKey: "2", key: "exporterName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Exporter Type", categoryName: categoryType.shipperDetails, eventKey: "10", key: "isExporter", type: filterType.normalFilter, label: "Exporter Type", viewAllPlaceHolder: "Search in Exporter Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "1", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "1", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Office Zone", categoryName: categoryType.ports, eventKey: "3", key: "standardLadingPortName", type: filterType.normalFilter, label: "Customs Office", viewAllPlaceHolder: "Search in Customs Office Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: categoryType.freightType, eventKey: "4", key: "transportMode", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "5", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "5", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight (kg)", categoryName: categoryType.cargoDetails, eventKey: "6", key: "weight", type: filterType.boxFilter, label: "Weight (kg)", viewAllPlaceHolder: "Search in Weight Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "7", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Value Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
    { heading: "Filter by Incoterm", categoryName: categoryType.freightType, eventKey: "22", key: "incoterm", type: filterType.normalFilter, label: "Incoterm", viewAllPlaceHolder: "Search in Incoterm Filter", emptyFilterText: "", searchFilterString: "", isNoTransform: true },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "derived_exporter_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Name" },
    { key: "derived_rut_number", label: "Shipper RUT Number" },
    { key: "hs_code", label: "HS Code" },
    { key: "dua", label: "Single Customs Document (DUA)" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_custom_office_name", label: "Custom Office" },
  ],
  shipmentSorting: [
    { columnKey: "date", value: "date", isDefault: true },
    { columnKey: "net_weight_item_kgs", value: "weight", isDefault: false },
    { columnKey: "customs_value_item_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "date",
    weight: "net_weight_item_kgs",
    shipment_value: "customs_value_item_usd",
  },
  sortKeyUniqueImpExpMap: {
    date: "doc_count",
    shipment_value: "shipment_value",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments Exported", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Weight", key: "total_weight", valuePrefix: "", valueSuffix: "Kg" },
    { label: "Total Shipment Value", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_destination_english", filterKey: "countryOfDestinationRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_custom_office_destination_name" },
    { key: "derived_custom_office_destination_name", filterKey: "standardLadingPortName", label: "Customs Offices", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination_english", profileType: redirectingProfileEnum.portOfLading.key },
    // { key: "derived_custom_office_destination_name_derived_country_of_destination_english", filterKey1: "standardLadingPortName", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Customs Office → Countries of Import)", headerOne: "Customs Office", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "derived_mode_of_transport_english", headerLabel: "HS Code", filterKey: "transportMode", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_destination_english" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true },
    { key: "date", name: "Shipment Date", selector: "date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true },
    { key: "hs_code", name: "HS Code", selector: "hs_code", dataTip: "", type: "", grow: 1, wrap: true },
    // {name: 'Product', selector: 'product_description', tooltipValue: 'product_description', type: '', grow: 1, wrap: true, isSliceEnabled: true, sliceLength: 40,},
    { key: "derived_commercial_item_quantity", name: "Quantity", selector: "derived_commercial_item_quantity", secondarySelector: "derived_commercial_item_measurement_unit", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "net_weight_item_kgs", name: "Net Weight (kg)", selector: "net_weight_item_kgs", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true },
    { key: "derived_country_of_destination_name", name: "Country of Import", selector: "derived_country_of_destination_name", dataTip: "", type: "", grow: 1, wrap: true },
    { key: "customs_value_item_usd", name: "Shipment Value (USD)", selector: "customs_value_item_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true },
    { key: "weight", name: "Net Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Shipment Date", value: "date", dateFormat: true, monthFormat: false },
        { label: "Single Customs Document (DUA)", value: "dua" },
        { label: "Item Number", value: "item_count" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport_english", tooltip: true, tooltipField: "mode_of_transport", tooltipPrefix: "" },
        { label: "HS Code", value: "hs_code" },
        { label: "Incoterm", value: "incoterm", capitalize: true, tooltip: true, tooltipField: "derived_incoterm_english", tooltipPrefix: "" },
        { label: "Purpose of Export", value: "derived_export_type_english", tooltip: true, tooltipField: "export_type_spanish", tooltipPrefix: "" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper Name", value: "derived_exporter_name" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name" },
        { label: "Shipper Type", value: "derived_is_exporter" },
        { label: "Shipper RUT Number", value: "derived_rut_number", tooltip: false, tooltipField: "" },
        { label: "Customs Office", value: "derived_custom_office_name", tooltip: false, tooltipField: "", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [{ label: "Country of Import", value: "derived_country_of_import", tooltip: true, tooltipField: "derived_country_of_destination", tooltipPrefix: "", countryFlag: true, countryCodeField: "derived_country_of_import_code" }],
    },
    {
      id: 4,
      isTitleDynamic: true,
      dynamicTitle: "dua",
      title: "DUA ID Details: ",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Customs Value DUA", value: "customs_value_dua_usd", valuePrefix: "USD ", tooltip: false, isCommaFormat: true, fixedValueUpto: 2 },
        { label: "Net Weight DUA", value: "net_weight_dua_kgs", valueSuffix: " kg", isCommaFormat: true, fixedValueUpto: 2 },
        { label: "Gross Weight DUA", value: "gross_weight_dua_kgs", valueSuffix: " kg", isCommaFormat: true, fixedValueUpto: 2 },
      ],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Item Number", value: "item_number", valuePrefix: "" },
        { label: "HS Code", value: "hs_code", valuePrefix: "" },
        { label: "Customs Value of Item", value: "customs_value_item_usd", valuePrefix: "USD ", unitField: "", dynamicUnit: false, unitField2: "", dynamicUnit2: false, tooltip: false, tooltipField: "", tooltipField2: "", isCommaFormat: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Net Weight", value: "net_weight_item_kgs", valueSuffix: " kg", isCommaFormat: true },
        { label: "Commercial Item Quantity", value: "derived_commercial_item_quantity", unitField: "derived_commercial_item_measurement_unit", dynamicUnit: true, isCommaFormat: true },
        { label: "Physical Item Quantity", value: "derived_physcial_item_quantity", unitField: "derived_physcial_item_measurement_unit", dynamicUnit: true, isCommaFormat: true },
      ],
    },
  ],
  defaultUeUiSecondLevelKey: "derived_country_of_destination_english",
  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    // derived_consignee_master_name:"Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    derived_country_of_destination_english: "Countries of Import",
    derived_custom_office_destination_name: "Customs Offices",
    // derived_custom_office_destination_name_derived_country_of_destination_english: "Trade Routes (Customs Offices → Countries of Import)",
    derived_mode_of_transport_english: "Mode of Transportation",

    six_digit_hs_code: "6 digit HS Codes",
  },
};

const UruguayExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default UruguayExportSearch;
